import { cn } from "@/lib/utils";

type LandingSectionHeaderProps = {
  eyebrow: string;
  title: string;
  copy?: string;
  align?: "left" | "center";
  className?: string;
};

export function LandingSectionHeader({
  eyebrow,
  title,
  copy,
  align = "left",
  className,
}: LandingSectionHeaderProps) {
  return (
    <div className={cn(align === "center" ? "mx-auto max-w-[78rem] text-center" : "max-w-[72rem]", className)}>
      <p className="text-sm font-semibold uppercase tracking-[0.09em] text-black/45">{eyebrow}</p>
      <h2 className="mt-4 text-[1.85rem] font-semibold leading-[1.05] tracking-[-0.06em] text-[hsl(var(--lb-clay))] sm:text-[3.4rem] lg:text-[4.4rem]">
        {title}
      </h2>
      {copy ? (
        <p className={cn("mt-4 text-[0.95rem] leading-[1.4] tracking-[-0.025em] text-black/58 sm:mt-5 sm:text-[1.25rem]", align === "center" && "mx-auto max-w-[60rem]")}>
          {copy}
        </p>
      ) : null}
    </div>
  );
}
